<script>
import Header from './Header.vue';
import customTooltip from '@/utils/customTooltip.js';

export default {
  name: 'Home',
  components: {
    'header-component': Header
  },
  mounted() {
    customTooltip();
  }
}
</script>

<template>
  <div role="main">
    <div class="top-wrap">
      <div class="top-content">
        <div class="top-banner">
          <header-component></header-component>
          <h1>Site Map</h1>
        </div>
      </div>
    </div>

    <div class="body">

     <ul class="site-map">
       <li>
         <router-link :to="{ name: 'Home'}" class="custom-tooltip" aria-label="Homepage">Home</router-link>
       </li>
       <li>
         <router-link :to="{ name: 'PopulationIdentificationProcesses'}" class="custom-tooltip" aria-label="Population Identification Processes">Population Identification Processes</router-link>
       </li>
       <li>
         <router-link :to="{ name: 'ExpandingInternalAwareness'}" class="custom-tooltip" aria-label="Expanding Internal Awareness">Expanding Internal Awareness</router-link>
       </li>
       <li>
         <router-link :to="{ name: 'CollaborativeCareResources'}" class="custom-tooltip" aria-label="Collaborative Care Resources">Collaborative Care Resources</router-link>
       </li>
       <li>
         <router-link :to="{ name: 'ProcessEvaluation'}" class="custom-tooltip" aria-label="Process Evaluation">Process Evaluation</router-link>
       </li>
       <li>
         <router-link :to="{ name: 'ResourceLibrary'}" class="custom-tooltip" aria-label="Resource Library">Resource Library</router-link>
       </li>
       <li>
         <router-link :to="{ name: 'SiteGuide'}" class="custom-tooltip" aria-label="Site Guide">Site Guide</router-link>
       </li>
       <li>
         <a href="https://www.janssen.com/us/privacy-policy" class="custom-tooltip" aria-label="Privacy Policy" target="_blank">Privacy Policy</a>
       </li>
       <li>
         <a href="https://www.janssen.com/us/legal-notice" class="custom-tooltip" aria-label="Legal Notice" target="_blank">Legal Notice</a>
       </li>
       <li>
         <router-link :to="{ name: 'ContactUs'}" class="custom-tooltip" aria-label="Contact Us">Contact Us</router-link>
       </li>
     </ul>

    </div>
  </div>



</template>

<style scoped>

#app > div {
  width: 100%;
  }

/*TOP */

  .top-wrap{
    background: rgb(0,18,82);
    background: linear-gradient(0deg, rgba(0,18,82,1) 0%, rgba(0,70,126,1) 50%, rgba(0,70,126,1) 100%);
    color: #ffffff;
    width: 100%;
    padding-bottom: 60px;
  }
  .top-content{
    background: linear-gradient(to top, #0079A8, #0084B8);
    border-radius: 0 0 0 100px;
    margin-left: 3%;
    padding-bottom: 50px;
    width: 97%;
  }
  .top-banner{
    background: url(../img/banner-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    margin-left: 1.5%;
    padding-bottom: 46px;
    width: 98.5%;
  }

.top-banner h1{
  display: block;
  font-size: 38px;
  font-family: "Gotham", sans-serif;
  color: #ffffff;
  font-weight: bold;
  line-height: 1.211;
  text-align: center;
  max-width:1121px;
  margin: 68px auto 42px auto;

}

.top-banner h1 span{
  display: block;
  font-family: "GothamBook", sans-serif;
  font-weight: 400;
}

.top-banner .super {
  font-size: 11px;
  font-weight: 400;
  margin: 0 0 0 2px;
  vertical-align: text-top;
}

.top-banner section{
  color: #ffffff;
  font-size: 18px;
  font-family: "GothamBook", sans-serif;
  font-weight: 500;
  line-height: 1.333;
  margin: 0 auto;
  max-width: 1030px;
  text-align: center;
}

.top-content p.banner-footer{
  color: #ffffff;
  font-family: "GothamBook", sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
}

.home-body{
  color: #363636;
  display: block;
  font-family: "GothamBook", sans-serif;
  font-size: 14px;
  line-height: 20px;
  margin: 50px auto 0 auto;
  width: 1121px;
}

.footer-references span{
  word-break: break-all;
}

.body{
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 14px;
  margin: 59px auto 0 auto;
  line-height: 17px;
  padding-bottom: 30px;
  position: relative;
  width: 90%;
}

.body a{
  word-break: break-all;
}

.body .references{
  display: block;
  font-family: acumin-pro, sans-serif;
  font-size: 14px;
  margin: 0;
  width: 1121px;
}

.subhead{
  font-size: 20px;
  font-weight: bold;
}

.body ul{
  list-style: disc;
  margin-left: 30px;
}
.body ul li{
  padding-top: 6px;
}

.body .site-map a{
  color: #003670;
  font-size: 14px;
  font-family: "Gotham", sans-serif;
  font-weight: 700;
  line-height: 30px;
  text-decoration: underline;
}

.site-guide, #menuToggle, #boton, .home{
  display: none;
}

@supports (-webkit-touch-callout: none) {
  .resources > div button{
    line-height: 65px;
  }
}


@media screen and (max-width: 1024px){

  .top-banner section{
    max-width: 95%;
  }

  footer img{
    left: 78%;
  }

  .top-banner *, .body * {
    max-width: 95%;
  }

  .home-body{
    max-width: 95%;
  }
}

@media screen and (max-width: 880px){

  .top-banner{
    background: url(../img/banner-mobile2-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    margin-left: 1.5%;
    padding-bottom: 46px;
    width: 98.5%;
  }

  .top-banner section{
    font-family: "GothamBook", sans-serif;
    font-size: 20px;
    line-height: 30px;
    font-weight: 100;
    width: 84%;
  }
  .top-banner section p{
    line-height: 20px;
  }

  .top-banner .super {
    font-size: 8px;
    font-weight: 100;
    margin: 0 0 0 2px;
    vertical-align: text-top;
}
  .top-content{
    padding-bottom: 28px;
  }

  .top-content p.banner-footer{
    font-size: 30px;
    margin: 24px auto;
    width: 73%;
  }

  .home-body{
    width: 87%;
  }

}

@media screen and (max-width: 540px){

  .top-banner h1{
    font-size: 19px;
    line-height: 23px;
    max-width: 85%;
    margin: 40px auto 21px auto;
  }

  .top-banner h1 span{
    display: block;
    font-size: 19px;
    line-height: 23px;
  }

  .top-banner section{
    font-size: 13px;
    line-height: 16px;
  }

  .top-content p.banner-footer{
    font-size: 15px;
    line-height: 18px;
  }

}

@media screen and (max-width: 320px){

  footer li[data-v-40ab164b]:nth-child(2n){
    width: 42%;
  }
}


/* new styles sergio */

@media screen and (max-width: 880px){

    .top-banner header .logo img{
      width: 60%;
    }

}


@media screen and (max-width: 415px){

  .top-wrap{
    padding-bottom: 20px;
  }

   @supports (-webkit-touch-callout: none) {
    .filter-list span{
      line-height: 32px;
    }

    .filter-content .apply{
      line-height: 70px;
    }

    .top-link{
      padding-top: 12px;
    }

  }

}

</style>



// WEBPACK FOOTER //
// src/components/Site_Map.vue